import React from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";

import quotes from "./Quotations.json";
import "./Css/Quotes.css";
const Quotes = () => {
  return (
    <>
      <Navbar />
      <center>

        <div className="Quotes">
          {
            quotes.quotes.map((e, idx) => {
              return (
                <p key={idx}>
                  {'"' + e + '"'}
                </p>
              )
            })
          }
          <p> - Er. P. Rohit V. Acharya</p>
        </div>
      </center>
      <Footer />
    </>
  );
};
export default Quotes;
